import { useState } from "react";
import Checkbox from "@rio-cloud/rio-uikit/Checkbox";
import { ITruckerPayPlanData } from "../../../../models/truckerPayPlan";
import { Button, Dialog, Tag } from "@rio-cloud/rio-uikit";

import "../../index.css";

interface IBudgetCoverageBalanceProps {
  truckerPay?: ITruckerPayPlanData;
  useCoverageBalance: boolean;
  hasCoverageBalance: boolean;
  isMobile?: boolean;
  onUseCoverageBalanceChange: (checked: boolean) => void;
}

const formatCurrency = (value: number): string => {
  return value.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const BudgetCoverageBalance = (props: IBudgetCoverageBalanceProps) => {
  const {
    truckerPay,
    useCoverageBalance,
    onUseCoverageBalanceChange,
    isMobile,
  } = props;

  const [showDialog, setShowDialog] = useState(false);

  const paddingX = isMobile ? 'px-2' : 'px-6';
  const balance = truckerPay?.availableCoverageBalance ?? 0;

  return (
    <div className={`mb-6 ${paddingX}`}>
      <div className="text-medium mr-10 text-size-18">Saldo da cobertura</div>
      <div
        className={`
          flex ${isMobile ? 'flex-col' : 'flex-row'} ${isMobile ? 'gap-2' : 'items-center justify-between'} padding-y-5 padding-x-15
          ${balance > 0 ? 'budget-coverage-balance' : 'budget-coverage-insufficient-balance'}
        `}
      >
        <div className="flex items-start flex-1">
          {
            balance > 0 ?
              <Checkbox
                className="!gap-2"
                checked={useCoverageBalance}
                onChange={() => {
                  if (!useCoverageBalance) {
                    setShowDialog(true);
                  } else onUseCoverageBalanceChange(false);
                }}
                aria-label="Usar saldo da cobertura para pagamento"
              >
                <span className="text-size-12 margin-left-5 font-semibold text-gray-500">
                  Desejo usar o saldo da minha cobertura para realizar o pagamento total ou parcial desta nota
                </span>
              </Checkbox> :
              <Tag size="small" className="tag">
                Saldo da minha cobertura insuficiente para realizar o pagamento
              </Tag>
          }
        </div>
        <div className={`flex flex-col ${isMobile ? 'items-start' : 'items-end'} shrink-0 ${isMobile ? 'pt-2' : ''}`}>
          <span className="text-size-11">Saldo da cobertura:</span>
          <span className={`font-bold ${balance > 0 ? '' : 'budget-coverage-insufficient-balance-value'} ${isMobile ? 'text-size-14' : 'text-size-20'}`}>
            {formatCurrency(balance)}
          </span>
        </div>
      </div>

      <Dialog
        show={showDialog}
        body={
          <div className="text-center width-100pct padding-50 !pb-8">
            <div className="text-size-16 padding-bottom-10">Você está usando o saldo da sua cobertura!</div>
            <div className="text-size-16 padding-bottom-10 text-color-dark">Ao selecionar esta opção, você estará descontando o valor da nota do saldo da sua carteira de cobertura. Deseja fazer isso?</div>

            <div className="flex justify-center gap-10 margin-top-20">
              <Button
                onClick={() => {
                  onUseCoverageBalanceChange(false);
                  setShowDialog(false);
                }}
              >
                Cancelar
              </Button>

              <Button
                bsStyle="primary"
                onClick={() => {
                  onUseCoverageBalanceChange(true);
                  setShowDialog(false);
                }}
              >
                Confirmar
              </Button>
            </div>
          </div>
        }
        bsSize={Dialog.SIZE_SM}
        onClose={() => setShowDialog(false)}
      />
    </div>
  );
};

export default BudgetCoverageBalance;
